import { Menu } from "@vidstack/react";
import { SubmenuButton } from "@/components/player/layouts/shared/menus/submenu-button";
import React from "react";
import { LanguageIcon } from "@vidstack/react/icons";
import LanguageMenuContent from "@/components/player/language/LanguageMenuContent";
import { usePlayerLanguageContext } from "@/components/player/language/PlayerLanguageContext";
import { getLanguageInfoByCode } from "@/lib/LanguageUtils";
export function LanguagesSubMenu({
  displayFlags
}: {
  displayFlags: boolean;
}) {
  const {
    languageTracks,
    selectedLanguage,
    setSelectedLanguage
  } = usePlayerLanguageContext();
  const onLanguageChange = (lang: string) => {
    console.log('Switching languages to', lang);
    setSelectedLanguage(lang);
  };
  return <Menu.Root className="vds-menu" data-sentry-element="unknown" data-sentry-component="LanguagesSubMenu" data-sentry-source-file="languagesSubMenu.tsx">
            <SubmenuButton label="Language" hint={getLanguageInfoByCode(selectedLanguage)?.label || ''} disabled={false} icon={LanguageIcon} data-sentry-element="SubmenuButton" data-sentry-source-file="languagesSubMenu.tsx" />
            <Menu.Content className="vds-menu-items" data-sentry-element="unknown" data-sentry-source-file="languagesSubMenu.tsx">
                <LanguageMenuContent languageTracks={languageTracks} selectedLanguage={selectedLanguage} onLanguageChange={onLanguageChange} displayFlags={displayFlags} data-sentry-element="LanguageMenuContent" data-sentry-source-file="languagesSubMenu.tsx" />
            </Menu.Content>
        </Menu.Root>;
}